import { useRef, useState, useEffect, use } from "react";
import css from "./text-input.module.css";

function TextInput({
  incomingPreviewText,
  incomingHandlePreviewTextChanges,
  incomingHandleVariablesChanges,
  incomingVariables,
}) {
  //Tailwind Styles

  //Text Input
  let tw_textInput_md = " md:w-[100%] md:p-[10px]";
  let tw_textInput_lg = " lg:w-[50%]";
  let tw_textInput_focus = " ";
  let tw_textInput_hover =
    " hover:shadow-[0_0_30px_rgba(100,100,100,0.35)] hover:text-main-color hover:border hover:border-main-color hover:border-solid";
  let incomVarSize =
    incomingVariables != undefined ? incomingVariables.size : 0;

  const [tempVariables, setTempVariables] = useState(new Map());

  function addVariableOnInput(e) {
    const textInput = e.currentTarget.value;
    incomingHandlePreviewTextChanges(textInput);
    // Search for {} in the text
    if (textInput.includes("{}") || incomVarSize != 0) {
      let searchPos = 0;
      let allBracketPositions = [];
      console.log("bracket size before:" + allBracketPositions.length);

      while (searchPos < textInput.length) {
        const bracketPos = textInput.indexOf("{}", searchPos);
        if (bracketPos === -1) break;
        allBracketPositions.push(bracketPos + 1);
        searchPos = bracketPos + 1;
      }
      let updatedVariables = new Map(incomingVariables);

      allBracketPositions.forEach((position, index) => {
        if (!updatedVariables.has(index)) {
          updatedVariables.set(index, {
            id: index,
            name: "Variable " + (index + 1),
            type: "Integer",
            value: 1,
            minValue: 1,
            maxValue: 10,
            iterate: true,
            interval: 1,
            randomize: false,
            displayText: "Display Text", //now that i think of it, should this be put inside a temp variable?
          });
        }
      });

      if (allBracketPositions.length < updatedVariables.size) {
        while (allBracketPositions.length < updatedVariables.size) {
          updatedVariables = deleteLatestVar(updatedVariables);
          incomingHandleVariablesChanges(updatedVariables);
          // console.log(incomingVariables.size);
        }
      } else incomingHandleVariablesChanges(updatedVariables);
    }
  }

  function deleteLatestVar(updatedVariables) {
    if (incomingVariables.size === 0) return;

    const lastKey = Array.from(updatedVariables.keys()).pop();
    if (lastKey !== undefined) {
      updatedVariables.delete(lastKey);
      console.log("Updated Var Deleted : " + updatedVariables);
      console.log(updatedVariables);
      // setTempVariables(tempMap);
      // incomingHandleVariablesChanges(updatedVariables);
      return updatedVariables;
    }
    // console.log("pakeEko");
    // setTempVariables(incomingVariables);

    // setTempVariables(tempVariables[tempVariables.size - 1);
    // // console.log(updatedVariables);
    // console.log("---------------");
    // incomingHandleVariablesChanges(setTempVariables);
    // console.log(incomingVariables);
  }

  // useEffect(() => {
  //   //delete variables
  // }, [incomVarSize]);

  // function enableEditing(element) {
  //   if (!element) return;
  //   element.setAttribute("contenteditable", true);
  //   element.focus();
  // }

  return (
    <>
      <div className="w-full h-fit flex justify-center items-center break-words">
        <textarea
          // contentEditable="true"
          className={
            "block align-top resize-none placeholder-slate-100  dark:!placeholder-gray-300 w-full h-fit max-w-[80%] bg-white bg-opacity-10 text-center flex justify-center items-center cursor-text rounded-[10px] p-[10px] shadow-[0_10px_30px_rgba(0,0,0,0.35)] backdrop-blur-[6px] backdrop-saturate-[120%]  rounded-[18px]" +
            tw_textInput_hover +
            tw_textInput_focus
          }
          placeholder="Type Text here.."
          value={incomingPreviewText != null ? incomingPreviewText : null}
          // onClick={(e) => enableEditing(e.target)}
          onChange={(e) => addVariableOnInput(e)}
        ></textarea>
      </div>
    </>
  );
}
export default TextInput;

//  // contentEditable="true"
//     className={
//       " h-full bg-main-color place-content-center border border-opposite-color cursor-text rounded-[10px] border-solid" +
//       tw_textInput_hover +
//       tw_textInput_focus +
//       tw_textInput_md +
//       tw_textInput_lg
//     }
